import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ListingEditPage from '../components/ListingEditPage'
import {
  actionCreators,
  IListingEditFiles,
  IListingEditState,
  selectError,
  selectFlyerFiles,
  selectIsLoading,
  selectIsReady,
  selectIsSaving,
  selectListing,
  selectMarketingPackageFiles,
} from '../modules/listingEdit'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IListingEditState & IListingEditFiles
    >({
      error: selectError(),
      flyerFiles: selectFlyerFiles(),
      isLoading: selectIsLoading(),
      isReady: selectIsReady(),
      isSaving: selectIsSaving(),
      listing: selectListing(),
      marketingPackageFiles: selectMarketingPackageFiles(),
    }),
    actionCreators,
  )(ListingEditPage),
)
